export default "__VITE_ASSET__Kpm7Y$o6__"